import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import 'vuetify/dist/vuetify.min.css'
import axios from 'axios';

var MobileDetect = require('mobile-detect'),
    md = new MobileDetect(window.navigator.userAgent);

Vue.use(Vuetify);
Vue.config.productionTip = false;
Vue.config.warnHandler = function (msg, vm, trace) {
};

export var store = new Vue({
    data: {
        selectedVessel: '',
        userLogged: false,
        userProfile: {},
        engineAggr: {},
        subSystemAggr: {},
        companyAggr: {},
        vesselTickets: {},
        selectedTicketsVessel: '',
        type: ''
    },
    methods: {
        is_mobile: function () {
            return md.mobile() != null;
        }
    },
    created() {
        axios.get('/config.json').then(async (response) => {
            this.config = response.data;

            await localStorage.setItem('config', JSON.stringify(response.data));

            if (! this.is_mobile()) {
                window.location.href = this.config.redirect_to + "/login";
            } else {
                this.MyEvent.fire('config_loaded');
            }
        });

        this.MyEvent = new class {
            constructor() {
                this.vue = new Vue();
            }

            fire(event, data = null) {
                this.vue.$emit(event, data);
            }

            listen(event, callback) {
                this.vue.$on(event, callback);
            }
        };
    }
});

export var vesselStore = new Vue({
    data: {
        selectedVessel: '',
        allowNav: true,
        userLogged: false,
        userProfile: {},
        signals: {},
        reference: {},
        mapping: {},
        units: {},
        loadDiagram: {},
        limits: {},
        type: '',
        faults: [],
        dashboard: {},
        mapData: [],
        mapDate: '',
        alertFilters: [],
        alerts: [],
        validDate: false,
        checkedDate: false
    },
    created() {}
});

new Vue({
    render: h => h(App),
    router
}).$mount('#app');
